<div class="td-loading-container" *ngIf="loadingSpinner">
  <mat-spinner class="td-loading"></mat-spinner>
</div>
<form [formGroup]="tdRegistrationForm">
	<div class="td-form-row td-full-form-w-hint">
		<mat-form-field class="td-full-form" >
		<mat-label>
			<fa-icon icon="envelope"></fa-icon>
			Email
		</mat-label>
		<input matInput formControlName="tdEmail" required type="email" aria-label="Email Address" autofocus>
			<mat-hint>This will also be your username when logging in</mat-hint>
			<mat-error *ngIf="!tdRegistrationForm.get('tdEmail').hasError('required')&&tdRegistrationForm.get('tdEmail').hasError('email')">Please enter a valid email</mat-error>
			<mat-error *ngIf="tdRegistrationForm.get('tdEmail').hasError('required')">Please enter an email</mat-error>
		</mat-form-field>
	</div>
	<div class="td-form-row">
		<mat-form-field class="td-first-form">
			<mat-label>
				<fa-icon icon="user"></fa-icon>
				First Name
			</mat-label>
			<input matInput formControlName="tdFirstName" required aria-label="First Name">
		</mat-form-field>
		<mat-form-field class="td-middle-form">
			<mat-label>
				<fa-icon icon="user"></fa-icon>
				Middle Name
			</mat-label>
			<input matInput formControlName="tdMiddleName" aria-label="Middle Name">
		</mat-form-field>
	</div>
	<div class="td-form-row">
		<mat-form-field class="td-full-form" >
			<mat-label>
				<fa-icon icon="user"></fa-icon>
				Last Name
			</mat-label>
			<input matInput formControlName="tdLastName" required aria-label="Last Name">
		</mat-form-field>
	</div>
	<div class="td-form-row">
		<mat-form-field class="td-full-form" >
			<mat-label>
				<fa-icon icon="phone"></fa-icon>
				Phone Number (optional)
			</mat-label>
			<input matInput formControlName="tdUserPhone" type="tel" aria-label="Telephone Number">
		</mat-form-field>
	</div>
	<div class="td-form-row" *ngIf="showUserType">
		<mat-form-field class="td-full-form">
			<mat-label>
				<fa-icon icon="university"></fa-icon>
				What type of user are you?
			</mat-label>
			<mat-select formControlName="tdUserType" required aria-label="Your Home Institution">
				<mat-option *ngFor="let op of userTypeOptions" [value]="op.value" (click)="homeInstitutionValidator()">
					{{ op.displayText }}
				</mat-option>			
			</mat-select>
		</mat-form-field>
	</div>
	<div class="td-form-row" *ngIf="(requireHomeInstitution && tdRegistrationForm.value.tdUserType === true) ||
																	(requireHomeInstitution && !showUserType && tdRegistrationForm.value.tdUserType === null)">
		<mat-form-field class="td-full-form" [class.td-full-form-w-hint]="!homeInstHint">
			<mat-label>
				<fa-icon icon="university"></fa-icon>
				Your Institution
				<span *ngIf="!homeInstHint">(optional)</span>
			</mat-label>
			<mat-select formControlName="tdHomeInstitution" aria-label="Your Home Institution" #homeInstitution [required]="homeInstHint">
				<mat-option>
					<ngx-mat-select-search formControlName="homeSearch" [searching]="searching"[placeholderLabel]="'Search...'"
					[noEntriesFoundLabel]="'No matching options found'"></ngx-mat-select-search>
				</mat-option>
				<mat-option *ngFor="let hi of filteredServerSideHomeInstitutions | async" [value]="hi.homeInstitutionFSCCode" aria-label="hi.homeInstitutionName">
					{{hi.homeInstitutionName}}
				</mat-option>
			</mat-select>
			<mat-hint *ngIf="!homeInstHint">If you are not currently at an institution you may skip this. Otherwise, please select your home institution.</mat-hint>
		  </mat-form-field>
	</div>
	<div class="td-form-row" *ngIf="requirePartnerInstitution">
		<mat-form-field class="td-full-form">
			<mat-label>
				<fa-icon icon="university"></fa-icon>
				Partner Institution
			</mat-label>
			<mat-select formControlName="tdPartnerInstitution" required aria-label="Partner Institution Name">
				<mat-option *ngFor="let pi of partnerInstitutionList" [value]="pi.partnerId" aria-label="pi.partnerName">{{ pi.partnerName }}</mat-option>
			</mat-select>
		  </mat-form-field>
	</div>
	<div class="td-form-row">
		<mat-form-field class="td-password-form">
			<mat-label>
				<fa-icon icon="lock"></fa-icon>
				Password
			</mat-label>
			<input matInput 
						 formControlName="tdPassword"  
						 [type]="hidePassWord ? 'password' : 'text'" 
						 required 
						 minlength="{{loginRegistrationOptions.passwordMinCharLength}}" 
						 maxlength="65" 
						 aria-label="Password" 						 
						 >

			<button mat-icon-button 
							matSuffix 
							(click)="hidePassWord = !hidePassWord" 
							[attr.aria-label]="'Hide password'" 
		 tabindex="-1"
		 type="button">
				<mat-icon>{{hidePassWord ? 'visibility_off' : 'visibility'}}</mat-icon>
			</button>
			<mat-error *ngIf="tdRegistrationForm.get('tdPassword').hasError('required')">Please enter a password</mat-error>
		</mat-form-field>
		<mat-form-field class="td-password-form" >
			<mat-label>
				<fa-icon icon="lock"></fa-icon>
				Password Confirmation
			</mat-label>
			<input matInput 
						 formControlName="tdPasswordConfirm"  
						 [type]="hidePassWordConfirm ? 'password' : 'text'" 
						 required 
						 aria-label="Confirm Password">
			<button mat-icon-button matSuffix (click)="hidePassWordConfirm = !hidePassWordConfirm" [attr.aria-label]="'Hide password'" tabindex="-1"
			type="button">
				<mat-icon>{{hidePassWordConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
			</button>
			<mat-error *ngIf="tdRegistrationForm.get('tdPasswordConfirm').hasError('minLength')">Passwords must have length of at least {{loginRegistrationOptions.passwordMinCharLength}} characters</mat-error>
			<mat-error *ngIf="tdRegistrationForm.get('tdPasswordConfirm').hasError('notMatch')">Passwords must match</mat-error>
			
		</mat-form-field>
	</div>
	<div class="td-form-row td-pw-hint-container">
		<span class="td-pw-hint" 
					*ngIf="loginRegistrationOptions.passwordMinCharLength > 0" 
					[class.td-pw-null]="tdRegistrationForm.get('tdPassword').value === ''"
					[class.td-pw-good]="tdRegistrationForm.get('tdPassword').value !== '' && !tdRegistrationForm.get('tdPassword').hasError('minlength')"
					[class.td-pw-bad]="tdRegistrationForm.get('tdPassword').hasError('minlength')">
			<span *ngIf="tdRegistrationForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
			<span *ngIf="tdRegistrationForm.get('tdPassword').value !== '' && !tdRegistrationForm.get('tdPassword').hasError('minlength')"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
			<span *ngIf="tdRegistrationForm.get('tdPassword').hasError('minlength')"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
			Password requires a min. length of {{loginRegistrationOptions.passwordMinCharLength}}
		</span>
		<span class="td-pw-hint"  
					*ngIf="loginRegistrationOptions.requirePasswordCharacter"
					[class.td-pw-null]="tdRegistrationForm.get('tdPassword').value === ''"
					[class.td-pw-good]="!tdRegistrationForm.get('tdPassword').hasError('pwNoSC') && tdRegistrationForm.get('tdPassword').value !== ''"
					[class.td-pw-bad]="tdRegistrationForm.get('tdPassword').hasError('pwNoSC') && tdRegistrationForm.get('tdPassword').value !== ''">
				<span *ngIf="tdRegistrationForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
				<span *ngIf="!tdRegistrationForm.get('tdPassword').hasError('pwNoSC') && tdRegistrationForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
				<span *ngIf="tdRegistrationForm.get('tdPassword').hasError('pwNoSC') && tdRegistrationForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
				Password requires special character</span>
		<span class="td-pw-hint"  
					*ngIf="loginRegistrationOptions.requirePasswordNumber"
					[class.td-pw-null]="tdRegistrationForm.get('tdPassword').value === ''"
					[class.td-pw-good]="!tdRegistrationForm.get('tdPassword').hasError('pwNoNumber') && tdRegistrationForm.get('tdPassword').value !== ''"
					[class.td-pw-bad]="tdRegistrationForm.get('tdPassword').hasError('pwNoNumber') && tdRegistrationForm.get('tdPassword').value !== ''">
				<span *ngIf="tdRegistrationForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
				<span *ngIf="!tdRegistrationForm.get('tdPassword').hasError('pwNoNumber') && tdRegistrationForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
				<span *ngIf="tdRegistrationForm.get('tdPassword').hasError('pwNoNumber') && tdRegistrationForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
				Password requires number</span>
		<span class="td-pw-hint"  
					*ngIf="loginRegistrationOptions.requirePasswordMixedCase"
					[class.td-pw-null]="tdRegistrationForm.get('tdPassword').value === ''"
					[class.td-pw-good]="!tdRegistrationForm.get('tdPassword').hasError('pwNoMixed') && tdRegistrationForm.get('tdPassword').value !== ''"
					[class.td-pw-bad]="tdRegistrationForm.get('tdPassword').hasError('pwNoMixed') && tdRegistrationForm.get('tdPassword').value !== ''">
				<span *ngIf="tdRegistrationForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
				<span *ngIf="!tdRegistrationForm.get('tdPassword').hasError('pwNoMixed') && tdRegistrationForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
				<span *ngIf="tdRegistrationForm.get('tdPassword').hasError('pwNoMixed') && tdRegistrationForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
		Password required the use of Uppercase and Lowercase characters</span>
</div>

	<button mat-flat-button  type="submit" class="td-form-register-button"  [style.background-color]="tdRegistrationForm.invalid ? null : primaryColor" (click)="siteRegistrationSubmit()" [disabled]="loadingSpinner || tdRegistrationForm.invalid"  aria-label="Register User">Register</button>
</form>